/** @format */
import createQuery from "../create-query";

//get application by id
export const useGetApplicationByID = createQuery({
  url: (application_id) => `/application/${application_id}`,
  method: "GET",
});

//get application chat by application id
export const useGetChatByApplicationID = createQuery({
  url: (application_id) => `/application/${application_id}/chat`,
  method: "GET",
});

//get application file by application id
export const useGetFileByApplicationID = createQuery({
  url: (application_id) => `/application/${application_id}/file`,
  method: "GET",
});

//get activity by application id
export const useGetActivityByID = createQuery({
  url: (activity_id) => `/application/activity/${activity_id}`,
  method: "GET",
});

//get application by job id
export const useGetApplicationByJobID = createQuery({
  url: (job_id) => `/application/job/${job_id}`,
  method: "GET",
});

//get application me
export const useGetApplicationMe = createQuery({
  url: "/application/me",
  method: "GET",
});
